import { Component, OnInit, Input } from '@angular/core';
import { WorkItemModel } from '../../../models/work-item';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'e5core-ui-work-item-box',
  templateUrl: './e5-core-ui-work-item-box.component.html',
  styleUrls: ['./e5-core-ui-work-item-box.component.css']
})
export class E5CoreUiWorkItemBoxComponent implements OnInit {

  @Input() workItem$: BehaviorSubject<WorkItemModel> ;
  @Input() workItem: WorkItemModel ;

  constructor() { }

  ngOnInit() {
  }

}
